<div class="flex min-h-screen gap-3 p-3">
  <div class="hidden md:flex flex-col justify-between gap-3 min-w-[250px]">
    <div class="overflow-y-auto">
      <img src="/assets/logo.svg" alt="Job Matcher logo" class="px-7 py-3" />
      <p-menu id="sidenav" [model]="sidenavItems"></p-menu>
    </div>
    <div>
      @if (user()) {
        <div id="user-info" class="text-xs text-center">
          Logged in as:<br />
          {{ user()?.firstName }} {{ user()?.lastName }} <br /><p-button [link]="true" (onClick)="logout()">Log out</p-button>
        </div>
      }
      <div class="text-center text-xs text-neutral-700">Version: {{ version }}</div>
    </div>
  </div>
  <div class="grow">
    <p-card id="header">
      <div class="flex">
        <div class="flex-1">
          <mglsk-breadcrumb [items]="breadcrumbs()" [home]="{ routerLink: '/' }"></mglsk-breadcrumb>
        </div>
        <div class="self-center">
          <mglsk-view-actions></mglsk-view-actions>
        </div>
      </div>
    </p-card>

    <div class="py-3">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
